import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
  /** Erlaubt Zugriff wenn EINE der Permissions zutrifft (Admin-Bypass via hasPermission). */
  anyOfPermissions?: string[];
  adminOnly?: boolean;
}

export function ProtectedRoute({ children, requiredPermission, anyOfPermissions, adminOnly = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, hasPermission, isAdmin } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-yellow" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  if (anyOfPermissions && anyOfPermissions.length > 0) {
    const allowed = anyOfPermissions.some((p) => hasPermission(p));
    if (!allowed) return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
